<!--
 * @Description: 系统设置用户设置
 * @Author: xu wei
 * @Date: 2020-02-26 15:23:42
 * @LastEditTime: 2020-05-05 17:02:38
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>用户设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <div class="pdb10">
        <el-button size="small" type="primary">添加</el-button>
      </div>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column prop="number" label="编号">
        </el-table-column>
        <el-table-column prop="productname" label="用户昵称">
        </el-table-column>
        <el-table-column prop="par" label="用户角色">
        </el-table-column>
        <el-table-column prop="name" label="用户状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.name" active-color="#4a90e2" inactive-color="#e4eaec">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" width='280'>
          <template>
            <el-button size="mini" type="info" @click="changepassword = true">修改密码</el-button>
            <el-button size="mini" type="primary" @click="editusers = true">编辑</el-button>
            <el-button size="mini" type="danger" @click.prevent="handleClose()">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="changepassword" @close="dialoginit" custom-class="gs_dialog" width="400px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li style="float: right;">
            <span class='tit'>旧密码</span>
            <span class="txtbox">
              <el-input v-model="oldpassword"></el-input>
            </span>
          </li>
          <li style="float: right;">
            <span class='tit'>新密码</span>
            <span class="txtbox">
              <el-input v-model="newpassword"></el-input>
            </span>
          </li>
          <li style="float: right;">
            <span class='tit'>确认新密码</span>
            <span class="txtbox">
              <el-input v-model="affirmpassword"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary">提交</el-button>
      </p>
    </el-dialog>
    <el-dialog title="编辑用户" :visible.sync="editusers" @close="dialoginit" custom-class="gs_dialog" width="400px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class='tit'>用户昵称</span>
            <span class="txtbox">
              <el-input v-model="username"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>用户名称</span>
            <span class="txtbox">
              <el-input v-model="nameuser"></el-input>
            </span>
          </li>
          <li>
            <span class='tit'>用户角色</span>
            <span class="txtbox">
              <el-input v-model="userroleleft"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary">提交</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numberperpage: '', // 每页数量
      numberdrow: '', // 每页数量下拉
      oldpassword: '', // 旧密码
      newpassword: '', // 新密码
      affirmpassword: '', // 确认新密码
      username: '', // 用户昵称
      nameuser: '', // 用户名称
      userroleright: '', // 用户角色
      userroleleft: '', // 用户角色
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: [
        {
          number: '1',
          productname: ''
        }
      ],
      changepassword: false,
      editusers: false
    };
  },
  methods: {
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
    },
    // 删除选中行
    handleClose() {
      this.$confirm('是否删除该用户?')
        .then((_) => {})
        .catch((_) => {});
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
</style>
